import {Injectable} from '@angular/core';
import {BBRestEndpointService} from '../@modules/bb-rest/bb-rest-endpoint.service';
import {Contact} from '../@models/contact.model';
import {Observable} from 'rxjs/Observable';
import {HttpErrorResponse} from '@angular/common/http';
import {Subject} from 'rxjs';

@Injectable()
export class ContactDBService {
  utilPrefix = 'utils';
  prefix = 'contacts';

  constructor(private api: BBRestEndpointService) {
  }

  validateMobile(mobileNumber: Contact.Validation.Input.Mobile): Observable<Contact.Validation.Output.Mobile> {
    return this.api.run_list_method('POST', this.utilPrefix, 'validate-mobile-number', {number: mobileNumber})
      .retryWhen(this.retry);
  }

  validateLandline(landlineNumber: Contact.Validation.Input.Landline): Observable<Contact.Validation.Output.Landline> {
    return this.api.run_list_method('POST', this.utilPrefix, 'validate-landline-number', {number: landlineNumber})
      .retryWhen(this.retry);
  }

  validateEmail(emailNumber: Contact.Validation.Input.Email): Observable<Contact.Validation.Output.Email> {
    return this.api.run_list_method('POST', this.utilPrefix, 'validate-email-address', {address: emailNumber})
      .retryWhen(this.retry);
  }

  retry(err: Subject<HttpErrorResponse>) {
    return err
      .flatMap((error: HttpErrorResponse) => {
        if (error.status === 0 || error.status === 504) {
          return Observable.of(error.status).delay(200);
        }
        return Observable.throw(error);
      })
      .take(5);
  }
}
